import React from "react";
import { Link } from "react-router-dom";
import {  FiPhone, FiMail } from "react-icons/fi";
import { FaFacebookF, FaGithub, FaTwitter, FaGoogle } from "react-icons/fa";
import { auth } from "../firebase"; // Add this import
import { useAuthState } from 'react-firebase-hooks/auth'; // Add this import

const ConicGradientOverlay: React.FC = () => (
  <div
    className="absolute pointer-events-none hidden sm:block"
    style={{
      width: 'min(90vw, 900px)',
      height: 'min(90vw, 900px)',
      top: '50%',
      right: '-25vw',
      background:
        'conic-gradient(from 180deg at 50% 50%, #FB1E1E 0deg, #FA5424 84.77deg, #C22C00 183.8deg, #982300 271.91deg, #FB1E1E 360deg)',
      opacity: '0.15',
      filter: 'blur(140px)',
      borderRadius: '50%',
      transform: 'translateY(-50%) rotate(-45deg)',
      zIndex: 0,
    }}
  />
);

const Footer: React.FC = () => {
  const [user] = useAuthState(auth); // Add this hook

  const getUsefulLinks = () => {
    if (user) {
      // Links for authenticated users
      return (
        <ul className="space-y-2 text-sm">
          <li>
            <Link
              to="/"
              className="!text-[#BCBCBC] hover:text-[#FF541F] transition-colors"
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/discover"
              className="!text-[#BCBCBC] hover:text-[#FF541F] transition-colors"
            >
              Discover
            </Link>
          </li>
          <li>
            <Link
              to="/startups"
              className="!text-[#BCBCBC] hover:text-[#FF541F] transition-colors"
            >
              Startup Search
            </Link>
          </li>
        </ul>
      );
    }

    // Links for non-authenticated users
    return (
      <ul className="space-y-2 text-sm">
        <li>
          <Link
            to="/"
            className="!text-[#BCBCBC] hover:text-[#FF541F] transition-colors"
          >
            Home
          </Link>
        </li>
        <li>
          <Link
            to="/about-us"
            className="!text-[#BCBCBC] hover:text-[#FF541F] transition-colors"
          >
            About
          </Link>
        </li>
        <li>
          <Link
            to="/use-cases"
            className="!text-[#BCBCBC] hover:text-[#FF541F] transition-colors"
          >
            Latest Use-Cases
          </Link>
        </li>
      </ul>
    );
  };

  return (
    <footer className="w-full text-gray-300 py-8 md:py-10 mt-auto bg-black bg-opacity-75 backdrop-blur-sm shadow-[0_-8px_30px_rgba(0,0,0,0.4)] border-t border-gray-800/20 relative overflow-hidden">
      <ConicGradientOverlay />
      <div className="max-w-[1440px] mx-auto px-4 md:px-12 lg:px-24 relative z-10">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mb-8">
          {/* Company Info */}
          <div className="space-y-4 min-w-0">
            <h3 className="text-white font-semibold text-xl sm:text-2xl tracking-tight">AI-Powered UCDP</h3>
            <p className="text-sm md:text-base leading-relaxed text-gray-400 break-words">
              Empowering organizations with intelligent AI use case discovery across sectors.
            </p>
          </div>

          {/* Useful Links */}
          <div className="space-y-4 min-w-0">
            <h3 className="text-base sm:text-lg font-semibold text-[#FF541F]">Useful Links</h3>
            {getUsefulLinks()}
          </div>

          {/* Help */}
          <div className="space-y-4 min-w-0">
            <h3 className="text-base sm:text-lg font-semibold text-[#FF541F]">Help</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/support" className="!text-[#BCBCBC] hover:text-[#FF541F] transition-colors">
                  Customer Support
                </Link>
              </li>
              <li>
                <Link to="/terms" className="!text-[#BCBCBC] hover:text-[#FF541F] transition-colors">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="!text-[#BCBCBC] hover:text-[#FF541F] transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/contact" className="!text-[#BCBCBC] hover:text-[#FF541F] transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect With Us */}
          <div className="space-y-4 min-w-0">
            <h3 className="text-base sm:text-lg font-semibold text-[#FF541F]">Connect With Us</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center space-x-2" style={{ color: "#BCBCBC" }}>
                <FiPhone className="text-[#FF541F]" />
                <span className="break-words">+91 8147100993</span>
              </li>
              <li className="flex items-center space-x-2" style={{ color: "#BCBCBC" }}>
                <FiMail className="text-[#FF541F]" />
                <span className="break-words">contactus@bigdatamatica.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#FF541F]">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-sm text-center md:text-left" style={{ color: "#BCBCBC" }}>
              © {new Date().getFullYear()} AI-Powered UCDP. All rights reserved.
            </div>
            <div className="flex gap-4 sm:gap-6 flex-wrap justify-center md:justify-end">
              <a href="#" className="group" aria-label="Facebook">
                <div className="border border-[#FF541F] rounded-full p-2 flex items-center justify-center transition-colors group-hover:border-[#ff6b3f]">
                  <FaFacebookF size={22} className="!text-[#FF541F] group-hover:text-[#ff6b3f]" />
                </div>
              </a>
              <a href="#" className="group" aria-label="GitHub">
                <div className="border border-[#FF541F] rounded-full p-2 flex items-center justify-center transition-colors group-hover:border-[#ff6b3f]">
                  <FaGithub size={22} className="!text-[#FF541F] group-hover:text-[#ff6b3f]" />
                </div>
              </a>
              <a href="#" className="group" aria-label="Twitter">
                <div className="border border-[#FF541F] rounded-full p-2 flex items-center justify-center transition-colors group-hover:border-[#ff6b3f]">
                  <FaTwitter size={22} className="!text-[#FF541F] group-hover:text-[#ff6b3f]" />
                </div>
              </a>
              <a href="#" className="group" aria-label="Google">
                <div className="border border-[#FF541F] rounded-full p-2 flex items-center justify-center transition-colors group-hover:border-[#ff6b3f]">
                  <FaGoogle size={22} className="!text-[#FF541F] group-hover:text-[#ff6b3f]" />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;